"use strict"

const stickyArea = document.getElementById("opt7_sticky_atc_section");
const originalTitle = document.querySelector("product-info .product__title");
const originalQuantity = document.querySelector(".price-per-item__container quantity-input");
const originalVariants = document.querySelector("product-info variant-radios");
const stickyButton = document.createElement("button");
const cartIcon = document.createElement("p");

const duplicateTitle = originalTitle.cloneNode(true);
const duplicateQuantity = originalQuantity.cloneNode(true);

stickyButton.classList = "button button--primary";
cartIcon.classList = "sticky-atc-shopping-cart-icon";
cartIcon.style.width = "20px";
cartIcon.style.height = "20px";
cartIcon.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 576 512\"><path d=\"M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z\"/></svg>";
stickyButton.innerHTML = "<span class='button__text'>Add to cart</span>";
stickyButton.prepend(cartIcon);
stickyButton.style.minWidth = "unset";

const isElementInViewport = (el) => {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.addEventListener("load", (event) => {
    duplicateQuantity.querySelector(".quantity__input").name =  "sticky-quantity"
    duplicateQuantity.querySelector(".quantity__input").id = `sticky-${originalQuantity.querySelector("input[name='quantity']").id}`;

    stickyArea.appendChild(duplicateTitle)
    stickyArea.appendChild(duplicateQuantity)
    stickyArea.appendChild(stickyButton)


    duplicateQuantity.querySelectorAll(".quantity__button").forEach(button => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            originalQuantity.onButtonClick(e);
        })
    })

    originalQuantity.querySelectorAll(".quantity__button").forEach(button => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            duplicateQuantity.onButtonClick(e);
        })
    })

    originalQuantity.querySelector("input[name='quantity']").addEventListener("keyup", (e) => {
        duplicateQuantity.querySelector("input[name='quantity']").value = e.target.value;
    })

    duplicateQuantity.querySelector("input[name='sticky-quantity']").addEventListener("keyup", (e) => {
        if (e.key === "Enter") {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
        originalQuantity.querySelector("input[name='quantity']").value = e.target.value;
    })

    stickyButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        document.querySelector("product-form .product-form__buttons .product-form__submit").click();
        window.scrollTo({top: 0, behavior: 'smooth'});
    })

    console.info(
        `%c Optimum7 Sticky ATC Initialized`,
        'color: #FFF; background:#ff9800;line-height:1.5;font-family:sans-serif;font-size:16px;font-weight:700;padding:6px 10px',
    );
});

window.addEventListener("scroll", () => {
    const atcButton = document.querySelector("product-info product-form .product-form__submit");
    const isSticky = !isElementInViewport(atcButton);
    if (stickyArea) {
        if (document.querySelector(".needsclick")) {
            document.querySelector(".needsclick").style.transition = `bottom 350ms ease`;
        }
        if (document.querySelector("#launcher")) {
            document.querySelector("#launcher").style.transition = `bottom 350ms ease`;
        }
        if (document.querySelector("#launcher + iframe")) {
            document.querySelector("#launcher + iframe").style.transition = `bottom 350ms ease`;
        }
        if (isSticky) {
            if (document.querySelector(".needsclick")) {
                document.querySelector(".needsclick").style.bottom = `${stickyArea.getBoundingClientRect().height}px`;
            }
            if (document.querySelector("#launcher")) {
                document.querySelector("#launcher").style.bottom = `${stickyArea.getBoundingClientRect().height + 16}px`;
            }
            if (document.querySelector("#launcher + iframe")) {
                document.querySelector("#launcher + iframe").style.bottom = `${stickyArea.getBoundingClientRect().height + 64}px`;
            }
            stickyArea.classList.add("sticky");
        } else {
            if (document.querySelector(".needsclick")) {
                document.querySelector(".needsclick").style.bottom = `0px`;
            }
            if (document.querySelector("#launcher")) {
                document.querySelector("#launcher").style.bottom = `16px`;
            }
            if (document.querySelector("#launcher + iframe")) {
                document.querySelector("#launcher + iframe").style.bottom = `64px`;
            }
            stickyArea.classList.remove("sticky");
        }
    }
})